import React from 'react';
import { formatCurrency } from 'utils';
import { Typography } from '@mui/material';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';

import { BasePrice, Charge } from '../../../types';

interface Props {
  field: keyof BasePrice;
  form: UseFormReturn<ListingForm<Charge>>;
}

export const ChargeTotalCell = ({ form, field }: Props) => {
  const bodyFields = useWatch({ control: form.control, name: 'bodyFields' });

  const total = (bodyFields ?? []).reduce<number>((total, row) => {
    if (typeof row.price[field] === 'number') {
      total += +row.price[field];
    }

    return total;
  }, 0);

  return <Typography>{formatCurrency(total, true)}</Typography>;
};
